module.exports = __webpack_public_path__ + "static/media/updateuser.0a7faa9b.svg";